<template>
  <FileDropWidget v-if="conversation" v-on:files-dragged="catchDraggedFiles" :conversationTimeWindowExpired="conversationTimeWindowExpired" :canScheduleMessage="canScheduleMessage">
    <div @click="clearContextMenu" class="messages-area relative border-l border-gray-200" v-if="conversation" v-bind:class="{ 'flex-grow messages-area-image': conversation }">
      <div class="flex pt-5 pb-5 pl-5 bg-white">
        <div class="xl:hidden text-center pr-4 pt-4 border-r border-gray-300 mr-5">
          <VLink href="/conversations" class="block">
            <ChevronDoubleLeftIcon class="h-5 w-5 inline-block" />
          </VLink>
        </div>
        <Avatar v-bind:customer="conversation.customer.attributes" />
        <div class="flex-grow">
          <div class="float-right pr-5 text-indigo-700 flex">
            <span class="hidden sm:block ">
              <AssignedAgentSelector v-on:change-assigned-agent="changeAssignedAgent" class="inline-block align-middle mr-3" v-bind:assignedAgentId="conversation.assigned_agent_id" />
              <AssignedGroupSelector v-on:change-assigned-group="changeAssignedGroup" class="inline-block align-middle mr-3" v-bind:assignedGroupId="conversation.assigned_group_id" />
              <ResolveConversation :conversation="conversation" v-on:toggle-closed="toggleClosed" />
            </span>
          </div>
          <h4 class="font-bold cursor-pointer" v-on:click="toggleProfile">
            {{ conversation.customer.attributes.name }}
          </h4>
        </div>
      </div>
      <div class="">
        <div id="message-items" class="p-2 overflow-y-scroll align-bottom flex flex-col scrollbar-thin scrollbar-thumb-indigo-300 scrollbar-track-indigo-50">
          <div class="message-item max-w-7xl mb-1" v-for="message of conversationMessages" v-bind:key="message.id">
            <Message v-bind:message="message" v-bind:conversation="conversation" v-bind:customer="customer" />
          </div>
          <TypingAgents :conversationId="conversationId" />
          <EndOfLifeMessages v-on:whatsapp-context-menu-requested="passWhatsappContextMenuOpen" :hasWhatsappMessages="hasWhatsappMessages" :isWhatsappChannel="isWhatsappChannel" :conversationTimeWindowExpired="conversationTimeWindowExpired" :canScheduleMessage="canScheduleMessage" :allChannelsDeleted="allChannelsDeleted" />
        </div>
      </div>
      <ReplyBox v-on:set-size-after="setSizeAfter" v-on:channel-selected="channelSelected" v-bind:customerChannels="customerChannels" :draggedFiles="draggedFiles" :whatsappContextMenuCloseRequest="whatsappContextMenuCloseRequest" :whatsappContextMenuOpenRequest="whatsappContextMenuOpenRequest" :conversationId="conversationId" :conversation="conversation" :conversationTimeWindowExpired="conversationTimeWindowExpired" :canScheduleMessage="canScheduleMessage" :deletedChannels="deletedChannels" :allChannelsDeleted="allChannelsDeleted" />
    </div>
    <div v-if="conversation && conversation.customer" class="bg-white absolute top-24 right-0  border-b border-t 2xl:border-t-0 2x-border-b-0 2xl:relative 2xl:inset-auto 2xl:block 2xl:flex-initial 2xl:w-80 border-l border-gray-200 max-w-xs overflow-y-scroll scrollbar-thin scrollbar-thumb-indigo-300 scrollbar-track-indigo-50" :class="{'hidden': !showCustomerProfile}">
      <CustomerProfile v-bind:customerChannels="customerChannels" v-bind:customer="conversation.customer" v-bind:conversation="this.conversation" :messages="conversationMessages" v-on:toggle-profile="toggleProfile" />
    </div>
  </FileDropWidget>
</template>

<script>
import Message from './MessageItem.vue'
import Avatar from './parts/AvatarWidget.vue'
import VLink from '../page/VLink.vue'
import AssignedAgentSelector from './parts/AssignedAgentSelector.vue'
import AssignedGroupSelector from './parts/AssignedGroupSelector.vue'
import ResolveConversation from './parts/ResolveConversation.vue'
import ReplyBox from "./parts/ReplyBox";
import TypingAgents from "./parts/TypingAgents";
import FileDropWidget from "./parts/FileDropWidget";

import CustomerProfile from './parts/CustomerProfile.vue'

import { useConversationsStore } from '@/stores/conversations'
import { useMessagesStore } from '@/stores/messages'
import { useFanpagesStore } from '@/stores/fanpages';
import { useCustomerChannelStore } from '@/stores/customerChannels';
import { useWhatsappMessagesStore } from '@/stores/whatsappMessageTemplates';
import conversationModel from "../../models/conversation";

import {
  ChevronDoubleLeftIcon,
} from '@heroicons/vue/outline'
import EndOfLifeMessages from "./parts/EndOfLifeMessages";
import customerChannelModel from "@/models/customerChannel";


function setSize() {
  let container = document.getElementById('message-items');
  let replyBox = document.getElementById('reply-box');
  if (container) {
    setTextInputSize();
    let replyHeight = replyBox.clientHeight;
    let height = window.innerHeight - container.offsetTop - replyHeight;
    container.style.height = `${height}px`;
  } else {
    setTimeout(setSize, 100);
  }
}

function scrollBottom() {
  let container = document.getElementById('message-items');
  container.scrollTo(0, container.scrollHeight);
}

function setTextInputSize() {
  setTimeout(function () {
    let element = document.getElementById('text');
    if (element) {
      element.style.width = `${element.offsetWidth}px`;
    } else {
      setTimeout(function () {
        setTextInputSize();
      }, 1000);
    }
  }, 100);
}


export default {
  name: 'App',
  emits: ['conversation-opened'],
  components: {
    EndOfLifeMessages,
    ReplyBox,
    Avatar,
    Message,
    VLink,
    AssignedAgentSelector,
    AssignedGroupSelector,
    CustomerProfile,
    ResolveConversation,
    TypingAgents,
    FileDropWidget,
    //
    ChevronDoubleLeftIcon,
  },
  setup() {
    let conversationsStore = useConversationsStore();
    let messagesStore = useMessagesStore();
    let fanpagesStore = useFanpagesStore();
    let whatsappMessagesStore = useWhatsappMessagesStore();
    let customerChannelStore = useCustomerChannelStore();
    return {
      conversationsStore,
      messagesStore,
      fanpagesStore,
      whatsappMessagesStore,
      customerChannelStore,
    };
  },
  created: function () {
    this.setSizeAfter();
    setTextInputSize();
    window.onresize = setSize;
    this.scrollToEndOfConversation();
    this.fetchCustomerChannelsForConversation(this.conversation);
    if (this.joinedConversations.indexOf(this.conversationId) === -1) {
      this.joinedConversations.push(this.conversationId);
      console.log('!! agent_join_conversation in created', this.conversationId);
      this.$root.messageEmit('agent_join_conversation', this.$root.token, this.conversationId);
    }
    this.$root.sockets.message.on('propagateMessage', (message) => {
      let action = this.messagesStore.replaceOrAdd(message);
      if (action === this.messagesStore.addActionLabel && !this.messagesLoadingScrollInterval) {
        setTimeout(() => {
          let scrolledPercentage = this.getScrolledPercentage();
          if (scrolledPercentage >= 0.9) {
            scrollBottom();
          }
        }, 0);
      }
    });
    setTimeout(() => {
      if(this.conversationId && !this.conversation) {
        this.$root.messageEmit('request_conversation', this.$root.token, this.conversationId);
      }
    }, 1000);
  },
  beforeUnmount() {
    if(this.messagesLoadingScrollInterval) {
      clearInterval(this.messagesLoadingScrollInterval);
    }
  },
  methods: {
    async fetchCustomerChannelsForConversation(conversation) {
      if (!conversation) {
        return;
      }
      let response = await customerChannelModel.getCustomerChannelsByIds(this.axios, this.$root.token, conversation.customer_channel_ids);
      response.data.data.forEach(customerChannel => {
        this.customerChannelStore.replaceOrAdd(customerChannel);
      });
    },
    clearContextMenu() {
      this.whatsappContextMenuCloseRequest = new Date();
    },
    setSizeAfter() {
      setTimeout(function () {
          setSize();
        }, 100);
    },
    getScrolledPercentage() {
      let container = document.getElementById('message-items');
      if (container) {
        let top = container.scrollTop;
        let position = container.scrollHeight - container.clientHeight;
        return top / position;
      }
      return undefined;
    },
    scrollToEndOfConversation() {
      if (this.messagesLoadingScrollInterval) {
        clearInterval(this.messagesLoadingScrollInterval);
      }
      this.messagesLoadingScrollInterval = setInterval(() => {
        this.scrollIterations += 1
        if (this.scrollIterations >= 30) {
          clearInterval(this.messagesLoadingScrollInterval);
          return;
        }
        let scrolledPercentage = this.getScrolledPercentage();
        if (scrolledPercentage === undefined || isNaN(scrolledPercentage)) {
          return;
        }
        let isAtBottom = scrolledPercentage >= 0.95;
        if (isAtBottom) {
          clearInterval(this.messagesLoadingScrollInterval);
          this.messagesLoadingScrollInterval = undefined;
          return;
        }
        if (scrolledPercentage < 0.95) {
          scrollBottom();
        }
      }, 100);
    },
    toggleProfile() {
      this.showCustomerProfile = !this.showCustomerProfile;
    },
    async toggleClosed() {
      let status;
      let agentId;
      if (this.conversation.assigned_agent_id) {
        agentId = this.conversation.assigned_agent_id;
      } else {
        agentId = this.$root.currentAgent.id;
      }
      if (this.conversation.status === 'closed') {
        if (this.conversation.assigned_agent_id) {
          status = 'assigned';
        } else {
          status = 'new';
        }
      } else {
        status = 'closed';
      }
      let data = conversationModel.buildUpdate(this.conversation.id, agentId, status, this.conversation.assigned_group_id);
      await this.updateConversation(data);
    },
    async changeAssignedAgent(agentId) {
      let data = conversationModel.buildUpdate(this.conversation.id, agentId, this.conversation.status, this.conversation.assigned_group_id);
      await this.updateConversation(data);
    },
    async changeAssignedGroup(groupId) {
      let data = conversationModel.buildUpdate(this.conversation.id, this.conversation.assigned_agent_id, this.conversation.status, groupId);
      await this.updateConversation(data);
    },
    async updateConversation(data) {
      try {
        await conversationModel.updateConversation(this.conversation.id, data, this.axios, this.$root.token);
      } catch(error) {
        alert(this.$t('conversation.errorUpdating'));
      }
    },
    passWhatsappContextMenuOpen() {
      this.whatsappContextMenuOpenRequest = new Date();
    },
    catchDraggedFiles(files) {
      this.draggedFiles = files;
    },
    channelSelected(channel) {
      this.selectedChannel = channel;
    },
  },
  watch: {
    conversationId: function(newId) {
      if(newId && this.joinedConversations.indexOf(newId) === -1) {
        console.log('!! agent_join_conversation conversationId changed', newId);
        this.joinedConversations.push(newId);
        this.$root.messageEmit('agent_join_conversation', this.$root.token, newId);
      }
      if (newId) {
        this.scrollIterations = 0;
        setTimeout(function () {
          setSize();
        }, 100);
        this.scrollToEndOfConversation();
      }
    },
    conversation: function (newConversation, oldConversation) {
      if (newConversation) {
        this.fetchCustomerChannelsForConversation(newConversation);
        if (!(oldConversation && oldConversation.status === 'assigned' && oldConversation.id === newConversation.id && newConversation.status === 'closed')) {
          this.$emit('conversation-opened', newConversation.status, newConversation.assigned_agent_id);
        }
      }
      if (newConversation && newConversation.assigned_agent_id && oldConversation && oldConversation.assigned_agent_id !== newConversation.assigned_agent_id) {
        if (newConversation.assigned_agent_id === this.$root.currentAgent.id) {
          this.conversationMessages.forEach(message => {
            if (message.status === 'new' && message.type === 'customer_message' && this.conversation.assigned_agent_id === this.$root.currentAgent.id) {
              this.$root.messageEmit('agent_read_message', this.$root.token, message.id, this.conversation.id);
            }
          })
        }
      }
    },
  },
  data() {
    return {
      agentReadMessageAlreadySent: [],
      showCustomerProfile: false,
      joinedConversations: [],
      messagesLoadingScrollInterval: undefined,
      scrollIterations: 0,
      whatsappContextMenuOpenRequest: undefined,
      whatsappContextMenuCloseRequest: undefined,
      draggedFiles: [],
      selectedChannel: undefined,
    }
  },
  computed: {
    customerChannels() {
      let result = this.customerChannelStore.getByIds(this.conversation.customer_channel_ids);
      if (result) {
        return result;
      } else {
        return [];
      }
    },
    customer: function () {
      if (this.conversation && this.conversation.customer) {
        return this.conversation.customer;
      } else {
        return {};
      }
    },
    conversation: function () {
      return this.conversationsStore.getById(this.conversationId);
    },
    conversationId: function () {
      return this.$root.RouteArgs[0];
    },
    assignedAgent() {
      return this.$root.agentStore.getById(this.conversation.assigned_agent_id);
    },
    conversationMessages() {
      return this.messagesStore.getConversationMessages(this.conversation.customer_channel_ids);
    },
    deletedChannels() {
      let deletedChannels = [];
      if (!this.customerChannels.forEach) {
        return deletedChannels;
      }
      this.customerChannels.forEach(channel => {
        if (channel.attributes.type === 'messenger') {
          let result = this.fanpagesStore.getByFanpageId(channel.attributes['identifier']);
          if (!result) {
            deletedChannels.push(channel.attributes['identifier']);
          }
        }
        if (channel.attributes.type === 'instagram') {
          let result = this.fanpagesStore.getByFanpageInstagramAccountId(channel.attributes['identifier']);
          if (!result) {
            deletedChannels.push(channel.attributes['identifier']);
          }
        }
      });
      return deletedChannels;
    },
    allChannelsDeleted() {
      return this.deletedChannels.length === this.customerChannels.length;
    },
    canScheduleMessage() {
      return this.conversation.latest_message.type === 'wa_templated_message';
    },
    conversationTimeWindowExpired() {
      return this.selectedChannel && !this.selectedChannel.attributes['reply-window-open'];
    },
    //
    recentChannelId() {
      if (this.conversation.latest_customer_message) {
        return this.conversation.latest_customer_message.customer_channel_id;
      }
      return '';
    },
    recentChannel() {
      if (this.recentChannelId) {
        return this.customerChannels.find(channel => {
          return channel.id === this.recentChannelId;
        });
      }
      return '';
    },
    hasWhatsappMessages() {
      if (!this.conversationTimeWindowExpired || !this.isWhatsappChannel) {
        return false;
      }
      return this.whatsappMessagesStore.activeTemplates().length > 0;
    },
    isWhatsappChannel() {
      return this.selectedChannel && this.selectedChannel.attributes.type === 'whatsapp';
    },
  },
}
</script>
